const GoalsPositionEnum = {
  'anti-frizz-hair-goal-concentrate': 1,
  'moisture-boosting-hair-goal-concentrate': 2,
  'shine-enhancing-hair-goal-concentrate': 3,
  'anti-frizz-hair-goal-booster': 1,
  'strengthen-hair-goal-booster': 2,
  'curl-definition-hair-goal-booster': 3,
  'lengthen-hair-goal-booster': 4
};

const PositionEnum = {
  'straight-hair-bond-repair-shampoo': { desktop: 1, mobile: 1 },
  'wavy-hair-bond-repair-shampoo': { desktop: 2, mobile: 3 },
  'curly-hair-bond-repair-shampoo': { desktop: 3, mobile: 5 },
  'coily-hair-bond-repair-shampoo': { desktop: 4, mobile: 7 },

  //masks
  'straight-hair-bond-repair-conditioner': { desktop: 5, mobile: 2 },
  'wavy-hair-bond-repair-conditioner': { desktop: 6, mobile: 4 },
  'curly-hair-bond-repair-conditioner': { desktop: 7, mobile: 6 },
  'coily-hair-bond-repair-conditioner': { desktop: 8, mobile: 8 },
  // leave in
  'straight-and-wavy-hair-bond-repair-leave-in-treatment': {
    desktop: 9,
    mobile: 9
  },
  'curly-and-coily-hair-bond-repair-leave-in-treatment': {
    desktop: 10,
    mobile: 10
  },
  'straight-hair-shampoo': { desktop: 1, mobile: 1 },
  'wavy-hair-shampoo': { desktop: 2, mobile: 3 },
  'curly-hair-shampoo': { desktop: 3, mobile: 5 },
  'coily-hair-shampoo': { desktop: 4, mobile: 7 },

  'straight-hair-conditioner': { desktop: 5, mobile: 2 },
  'wavy-hair-conditioner': { desktop: 6, mobile: 4 },
  'curly-hair-conditioner': { desktop: 7, mobile: 6 },
  'coily-hair-conditioner': { desktop: 8, mobile: 8 },

  'straight-gentle-hair-shampoo': { desktop: 1, mobile: 1 },
  'wavy-hair-gentle-shampoo': { desktop: 2, mobile: 3 },
  'curly-hair-gentle-shampoo': { desktop: 3, mobile: 5 },
  'coily-hair-gentle-shampoo': { desktop: 4, mobile: 7 },

  'straight-hair-gentle-conditioner': { desktop: 5, mobile: 2 },
  'wavy-hair-gentle-conditioner': { desktop: 6, mobile: 4 },
  'curly-hair-gentle-conditioner': { desktop: 7, mobile: 6 },
  'coily-hair-gentle-conditioner': { desktop: 8, mobile: 8 }
};

export { PositionEnum, GoalsPositionEnum };
